import { render, staticRenderFns } from "./UserAdminEdit.vue?vue&type=template&id=17161ebe&scoped=true&"
import script from "./UserAdminEdit.vue?vue&type=script&lang=js&"
export * from "./UserAdminEdit.vue?vue&type=script&lang=js&"
import style0 from "./UserAdminEdit.vue?vue&type=style&index=0&id=17161ebe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17161ebe",
  null
  
)

export default component.exports